import { features } from '@/mocks/features';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            特色优势
          </h2>
          <p className="text-sm text-foreground-500">为什么百万瓜友选择爆瓜网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-accent-300/60 transition-all group cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100/80 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}